import React, {FormEvent, useRef} from "react"
import {Modal} from "../../../components-shared/modal/modal"
import {HeadingMedium, HeadingSmall} from "../../../components-shared/heading/heading"
import {WithVerticalSpacing} from "../../../components-shared/spacing/with-vertical-spacing"
import {FormSingleSelect} from "../../../components-shared/forms/form-single-select/form-single-select"
import {FormSubmitButton, SubmitState} from "../../../components-shared/forms/form-submit-button/form-submit-button"
import {Bank, bankFormats} from "./bank-format"
import {ImportTransactionsFailureResponse} from "../../../services/api/transactions-api"
import {FormTextInput} from "../../../components-shared/forms/form-text-input/form-text-input-view"
import {validateRequiredField} from "../../../util/validation/validations"

interface ImportModalViewProps {
  show: boolean
  bank: Bank | null
  setBank: (bank: Bank | null) => void
  fileName: string
  setFileName: (fileName: string) => void
  onBlur: (field: "bank" | "file") => void
  visibleValidationResults: VisibleValidationResults
  closeModal: () => void
  importSubmitState: SubmitState
  onSubmit: (bank: Bank | null, file: File | null) => Promise<void>
  importFailureResponse: ImportTransactionsFailureResponse | null
}

export interface VisibleValidationResults {
  bank: boolean
  file: boolean
}

export const ImportModalView : React.FC<ImportModalViewProps> = ({show, bank, setBank, fileName, setFileName, onBlur, visibleValidationResults, closeModal, importSubmitState, onSubmit, importFailureResponse}) => {
  const fileInput = useRef<HTMLInputElement>(null)

  const bankFormatSelectItems: Array<{id: string | null, component: string}> = bankFormats.map(bankFormat => {
    return {
      id: bankFormat.bank,
      component: bankFormat.displayName
    }
  })

  const handleCloseModal = () => {
    closeModal()
  }

  const getFile = () => {
    return (fileInput.current !== null && fileInput.current.files !== null && fileInput.current.files.length > 0)
      ? fileInput.current.files[0]
      : null
  }

  const handleSetBank = (bank: Bank) => {
    setBank(bank)
    onBlur("bank")
  }

  const updateFileName = () => {
    const file = getFile()
    setFileName(file !== null ? file.name : "")
    onBlur("file")
  }

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()

    const file = getFile()

    await onSubmit(bank, file)
  }

  const bankValidationResult = validateRequiredField(bank ?? "")
  const fileValidationResult = validateRequiredField(fileName)

  return <Modal show={show} closeModal={handleCloseModal} minHeight="70">
    <form onSubmit={handleSubmit}>
      <WithVerticalSpacing>
        <HeadingMedium>Importeren</HeadingMedium>
        <FormSingleSelect label="Bankformaat" items={bankFormatSelectItems} selectedItemId={bank} onChange={handleSetBank} showValidity={visibleValidationResults.bank} validationResult={bankValidationResult}/>

        <FormTextInput label="Bestand" type="file" value="" onChange={updateFileName} forwardRef={fileInput} showValidity={visibleValidationResults.file} validationResult={fileValidationResult}/>

        <FormSubmitButton submitState={importSubmitState} contents="Importeren"/>

        {importFailureResponse !== null && <WithVerticalSpacing>
          <HeadingSmall>Fout opgetreden</HeadingSmall>
          {importFailureResponse.title}

          <HeadingSmall>Details van de eerste fout</HeadingSmall>
          {importFailureResponse.Errors[0].FieldParseResults[0].errorMessage}
        </WithVerticalSpacing>}
      </WithVerticalSpacing>
    </form>
  </Modal>
}
